import { render, staticRenderFns } from "./SingleDescrRow.vue?vue&type=template&id=508c4862"
import script from "./SingleDescrRow.vue?vue&type=script&lang=js"
export * from "./SingleDescrRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports